import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import lightningTrivia from "assets/images/sbs/lightningTrivia.png";
import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";

const AfterAnswerSubmit = ({
  mobile_app,
  questionObj,
  lts = false,
  answers_array,
  question_params,
  top_logo_mobile,
  current_player_answer,
  current_player_answer_time
}) => {
  const your_answer = _.get(question_params, "your_answer", "Your Answer:");
  const your_time = _.get(question_params, "your_time", "Your Time:");
  const answered_text = _.get(
    question_params,
    "answered_text",
    "Hang on, we'll show you the correct answer in a sec!"
  );

  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const buttonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw" }
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0.2 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.2 }
  };

  return (
    <div
      className={`container Lightning-trivia-2 res-screen ${
        mobile_app ? "mobile-cnt" : "web-cnt"
      } ${top_logo_mobile ? "global" : ""}`}
    >
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper"
      >
        <img
          src={
            lts
              ? TriviaSubmit
              : top_logo_mobile
              ? top_logo_mobile
              : lightningTrivia
          }
          className="logoimage"
          alt="sbsLogo"
        />
        <motion.div variants={buttonVariants} className="sbs-trivia-title">
          <h2 className="mediamText blueText darkBlueText">
            {questionObj?.question}
          </h2>
        </motion.div>
        <motion.h3 variants={textVariants} className="mediamText blueText">
          {your_answer}
        </motion.h3>
        <motion.button
          disabled
          variants={textVariants}
          className="sbsButton answerBtn textButton margin52"
        >
          {answers_array[current_player_answer]}
        </motion.button>
        <motion.h1 variants={textVariants} className="mediamText blueText ">
          {your_time}
        </motion.h1>
        <motion.p variants={textVariants} className="largeText whiteText">
          {current_player_answer_time} Seconds
        </motion.p>
        <motion.p
          variants={textVariants}
          className="mediamText blueText text-message hangOnMargin"
        >
          {answered_text}
        </motion.p>
      </motion.div>
    </div>
  );
};

export default AfterAnswerSubmit;
